module.exports = __webpack_public_path__ + "static/img/login_success.8aaae7d4.png";